/**
 * ページタイトルの SVG：<use> をインライン展開し、path ごとにカクカクアニメーションを付与
 * （<use> 内の path は CSS で直接指定できないため、シンボル内容をクローンして展開する）
 */

const TITLE_SYMBOL_PREFIX = "#title-";
const CHAR_CLASS = "title-char";
const STAGGER_MS = 80;

function getSymbolId(useEl) {
  const href =
    useEl.getAttribute("xlink:href") || useEl.getAttribute("href") || "";
  return href.startsWith("#") ? href.slice(1) : href;
}

function cloneSymbolContent(symbol) {
  const fragment = document.createDocumentFragment();
  Array.from(symbol.children).forEach((child) => {
    fragment.appendChild(child.cloneNode(true));
  });
  return fragment;
}

function collectPaths(node, list = []) {
  if (node.nodeName?.toLowerCase() === "path") {
    list.push(node);
  }
  Array.from(node.children || []).forEach((child) => collectPaths(child, list));
  return list;
}

function expandUse(useEl) {
  const symbolId = getSymbolId(useEl);
  if (!symbolId || !symbolId.startsWith("title-")) return null;

  const symbol = document.getElementById(symbolId);
  if (!symbol) return null;

  const viewBox = symbol.getAttribute("viewBox");
  const content = cloneSymbolContent(symbol);
  const wrapper = document.createElementNS("http://www.w3.org/2000/svg", "g");
  wrapper.setAttribute("class", useEl.getAttribute("class") || "");
  wrapper.appendChild(content);

  const paths = collectPaths(wrapper);
  paths.forEach((path, i) => {
    path.classList.add(CHAR_CLASS);
    path.style.animationDelay = `${i * STAGGER_MS}ms`;
  });

  return { wrapper, viewBox };
}

const MEDIA_LG = "(min-width: 1024px)";

function setTitleSvgViewBox(svg) {
  const viewBoxPc = svg.dataset.viewboxPc;
  const viewBoxSp = svg.dataset.viewboxSp;
  if (viewBoxPc && viewBoxSp) {
    svg.setAttribute(
      "viewBox",
      window.matchMedia(MEDIA_LG).matches ? viewBoxPc : viewBoxSp
    );
  } else if (viewBoxPc) {
    svg.setAttribute("viewBox", viewBoxPc);
  }
}

function processTitleSvg(svg) {
  if (svg.dataset.titleExpanded) return;
  const uses = Array.from(svg.querySelectorAll("use"));
  if (uses.length === 0) return;
  svg.dataset.titleExpanded = "1";

  const results = uses.map(expandUse).filter(Boolean);
  if (results.length === 0) return;

  if (results.length >= 2) {
    if (results[0].viewBox) svg.dataset.viewboxPc = results[0].viewBox;
    if (results[1].viewBox) svg.dataset.viewboxSp = results[1].viewBox;
  } else if (results[0].viewBox) {
    svg.dataset.viewboxPc = results[0].viewBox;
  }

  setTitleSvgViewBox(svg);

  uses.forEach((useEl) => useEl.remove());
  results.forEach(({ wrapper }) => svg.appendChild(wrapper));

  const mql = window.matchMedia(MEDIA_LG);
  mql.addEventListener("change", () => setTitleSvgViewBox(svg));
}

function processTitleText(el) {
  if (el.dataset.titleAnimated) return;

  const originalText = el.textContent || "";
  const text = originalText.replace(/\s+$/g, "");
  if (!text) return;

  el.textContent = "";

  Array.from(text).forEach((ch, i) => {
    const span = document.createElement("span");
    span.textContent = ch;
    span.classList.add(CHAR_CLASS);
    span.style.animationDelay = `${i * STAGGER_MS}ms`;
    el.appendChild(span);
  });

  el.dataset.titleAnimated = "1";
}

function init() {
  const svgs = document.querySelectorAll("h1.js-title-choppy svg");
  svgs.forEach((svg) => {
    const uses = Array.from(svg.querySelectorAll("use")).filter((u) => {
      const href = u.getAttribute("xlink:href") || u.getAttribute("href") || "";
      return href.includes("title-");
    });
    if (uses.length > 0) processTitleSvg(svg);
  });

  const textTitles = document.querySelectorAll(".title-animate");
  textTitles.forEach((el) => processTitleText(el));
}

document.addEventListener("DOMContentLoaded", init);
